<!-- Localized -->
<template>
    <div class="relative h-full flex flex-col text-base-content" v-allow:auth="'package.read'" >
        <sub-header :showBtn="showReplaceWorkflow" :handleClick="handleReplaceWorkflow" :buttonText="$t('pages.tenant_packages.replace_workflow')" :backButton="true" class="mb-4" backRedirectionUrl="/packages" :customCrumbLists="customBreadCumbs" :handleBackSection="setEditModeUnlock"/>
        <div class="w-full h-full overflow-hidden" v-allow:auth="'package.edit'">
            <div class="flex h-full gap-4 flex-1 overflow-hidden">
                <div class="w-2/12 rounded-lg self-start bg-card-bg shadow flex flex-col gap-x-4 h-full overflow-y-auto scroll-bar">
                    <div
                        @click="handleCurrentTab(nav)"
                        v-for="(nav, idx) in getVisibleNavigations"
                        :key="idx"
                        class="px-4 py-3 transition-all relative duration-200 items-center text-sm font-medium flex gap-3  cursor-pointer"
                        :class="{
                            'bg-primary-300 text-white-text': currentTab === nav.nav,
                            'hover:bg-gray-100 hover:text-base-content-600': currentTab !== nav.nav,
                            'border-t border-0' : idx != 0
                        }"
                    >
                        <!-- :style="{borderColor: currentTab === nav.nav ? '#cdcdcd': '' }" -->
                        <font-awesome-icon :icon="[nav.iconPrefix || 'fa', nav.icon]" />
                        {{ nav.title }}
                        <!-- <font-awesome-icon class="text-gray-500 absolute right-2" v-if="currentTab === nav.nav" icon="arrow-right" /> -->
                    </div>
                </div>
                <!-- TODO: loader -->
                <div v-if="loader" class="flex flex-1 gap-3 w-full h-full justify-center items-center">
                    <Loader />
                </div>
                <div v-else class="flex flex-col flex-1 gap-3 w-full h-full overflow-hidden">
                    <Tabs
                        class="entity-type-tabs border-b w-full"
                        v-if="currentTabConfig.tab.entityTypeTabs && entityTypeTabs.length"
                        v-model="selectedEntityType"
                        :tabs="entityTypeTabs"
                        no-content
                    />
                    <!-- currentTab != 'workflow' &&  -->
                    <UISection
                        v-if="getPackage"
                        :class="{
                            'description_height': currentTab === 'description',
                            'overflow-y-hidden': currentTab !== 'description',
                        }"
                    >
                        <template #title>
                            <div class="flex justify-between items-center w-full">
                                <div>
                                    <span class="text-white-text">{{ $t('pages.tenant_packages.package') }} </span>
                                    <span class="font-normal text-white-text">{{ originPackageData.package_name }}</span>
                                </div>
                               
                            </div>
                        </template>
                        <template #deletebutton v-allow:auth="'package.delete'" v-if="currentTab === 'description' &&  checkPermission('package.delete')">
                             <button v-allow="'package.delete'" v-if="$route.params.action !== 'view'" @click="handleDeletePackage()" :disabled="$route.params.action == 'view'" class="btn btn-outline bg-red-500 text-white-text btn-circle hover:bg-red-600 border-none btn-sm check-delete-btn ml-4">
                                    <font-awesome-icon icon="trash" />
                                </button>
                        </template>
                       
                        <div
                            class="w-full scroll-bar"
                            style="max-height: 72vh;"
                        >
                    
                        </div>
                        <component
                            :is="currentTabConfig.component.el"
                            :ref="currentTab"
                            v-bind="currentTabConfig.component.props"
                        />
                 
                    </UISection>
                    <div
                        v-else
                        class="flex flex-1 bg-card-bg p-3 h-full overflow-y-scroll scroll-bar justify-center items-center"
                    >
                    {{ $t('pages.tenant_packages.no_options_selected') }}
                    </div>

                    <!-- Revetting -->
                     <div  v-if="currentTab === 'workflow'  && checkPermission('package.allowRefreshingConfig')" class="flex flex-col bg-white rounded-xl justify-center p-4 shadow-md gap-4">
                        <div class="flex items-center w-full gap-4" :class="selectedRevettingWorkflow ? 'h-full' : 'h-10'" v-if="!allowRevetting.loader">
                            <div class="flex">
                                <label class="useDefault flex items-center gap-2">
                                    <Checkbox class="" v-model="allowRevetting.toggle" @input="handleAllowRefresh"/>
                                    <span class="text-base-content font-semibold cursor-pointer">
                                        {{ $t('pages.tenant_packages.allow_refresh') }}
                                    </span>
                                </label>
                            </div>
                            <div class="flex" v-if="allowRevetting.toggle || selectedRevettingWorkflow">
                                <FormulateInput
                                    v-model="selectedRevettingWorkflow"
                                    :placeholder="$t('pages.tenant_packages.select_refresh_workflow')"
                                    type="multi-select"
                                    :multiple="false"
                                    variant="alt"
                                    :options="allowRevetting.workflowOption"
                                    :config="{ label: 'name', trackBy: 'id' }"
                                    @input="onSelectAllowRevettingWorkflow"
                                    :element-class="
                                    (context, classes) => ['flex-1 min-w-full'].concat(classes)
                                    "
                                    :disabled="!allowRevetting.toggle"
                                />
                            </div>
                        </div>

                        <div class="flex w-full" v-if="showRevettingWorkflow && !allowRevetting.loader">
                            <RevettingWorkflow :revettingWorkflowDetail="selectedRevettingWorkflow" :key="selectedRevettingWorkflow?.id"/>
                        </div>
                        <div class="flex w-full justify-center items-center" v-if="allowRevetting.loader">
                            <Loader v-if="allowRevetting.loader" />
                        </div>
                     </div>
                </div>
            </div>
        </div>
        <modal-confirm 
            :title="$t('general.are_you_sure')" 
            :message="$t('general.confirm_unsaved_data_lost')"
            ref="confirm-popup"> 
        </modal-confirm>
        <deletePackageModal
            :open="deletePackageModalOpen"
            v-if="fieldData"
            :field="fieldData"
            @close="closeDeletePackageModal"
            :packageName="originPackageData.package_name"
            :packageDetails="originPackageData"
            :assignedToClients="assignedToClients"
            @handle-delete="handleDelete"
            :isDeleteLoading="isDeleteLoading"
        />
    </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { default as rawAxios } from "@/axios";
import SubHeader from "@/components/SubHeader";
import Button from "@/components/button";
import Tabs from "@/components/dashboard-components/tabs";
const Description = () => import("@/components/tenant-packages/description/description");
const Checks = () => import("@/components/tenant-packages/checks");
const FormEditor = () => import("@/components/tenant-packages/form-editor");
const Tat = () => import("@/components/tenant-packages/tat/tat");
const FormPreview = () => import("@/components/tenant-packages/form-preview");
const Audit = () => import("@/components/tenant-packages/audit");
const EmailSequence = () => import("@/components/tenant-packages/email-sequence")
const EmailTemplateSequence = () => import("@/components/tenant-packages/email-template-sequence")
const LinkSetting = () => import("@/components/tenant-packages/link-setting/index")
const Workflow = () => import("@/components/tenant-packages/workflow");
const RevettingWorkflow = () => import("@/components/tenant-packages/workflow/revetting-workflow.vue");

const Templates = () => import("@/components/tenant-packages/templates");
const modalConfirm = () => import("@/components/modal-confirm");
import Checkbox from "@/components/checkbox";
import { reorderPackageEntityTypes } from "@shared/utils/functions";
import { checkPermission } from "@shared/utils/functions";
import { EventBus } from "@/main.js";
import { fetchStatusList } from "@shared/workflow/service.js";
import Loader from "@shared/loader";
const deletePackageModal = () => import("@/pages/tenant-packages/deletePackageModal.vue");

export default {
    title: 'Packages',

    name: "screeing-package-view",

    components: {
        SubHeader,
        "neo-button": Button,
        description: Description,
        checks: Checks,
        EmailSequence,
        LinkSetting,
        // RiskAssessment,
        modalConfirm,
        deletePackageModal,
        Tabs,
        Checkbox,
        RevettingWorkflow,
        Loader
    },

    data: () => ({
        currentTab: null,
        componentData: null,
        customBreadCumbs: [],
        selectedEntityType: null,
        isEntityTypesLoading: false,
        allowRevetting: {
            toggle: false,
            workflowOption: [],
            loader: false,
        },
        selectedRevettingWorkflow: null,
        loader: false,
        deletePackageModalOpen: false,
        isDeleteLoading: false,
        assignedToClients: [],
    }),
    async mounted() {
        // await this.$store.dispatch('fetchPermissions')
        try {
            this.loader = true;
            let roles = this.getRoles;
            if (!roles.length) {
                await this.fetchRoles();
            }
            if (!this.getPackage)
                await this.fetchPackage()
            
            this.resetSelectedEntityTab();

            await this.fetchEntityTypeOptions();
            await this.fetchEntityTypeOptions();
            await this.getPackageAssignedUsers();

            // TODO: Fix Workaround to render workflow inner tabs after page reloading/redirection
            if (this.currentTab === "stateTransitions" || this.currentTab === "triggerAndActions") {
                await this.handleCurrentTab(this.navigations.find((el) => el.nav === "workflow"))
            }
            this.loader = false;

            if(this.currentTab === 'workflow') {
                this.allowRevetting.loader =  true; 
                await this.fetchRevettingWorkflowOptions();
                await this.fetchSelectedRevetting();
                this.allowRevetting.loader =  false; 
            }
        } catch (error) {
             this.allowRevetting.loader =  false;
             this.loader = false; 
            console.error("Error in mounted:", error);
        }
       
    },
    created() {
        let params = this.$route.params;
        console.log("params", params);

        // reset to update package data:
        this.RESET_PACKAGE()

        if (params.packagetool) {
            this.currentTab = params.packagetool;
            this.$route.meta.customCrumbs = [{ name: params.packagetool }];
            this.$forceUpdate();
        } else {
            this.currentTab = this.navigations[0].nav;
            this.$router.push({
                name: "Package Tools",
                params: { packagetool: this.navigations[0].nav },
            });
            this.setBredCrumbs(this.currentTab)
            this.$forceUpdate();
        }
    },
    computed: {
        ...mapGetters([
            "getPackage",
            "getRoles",
            "getPackageSections",
            "getPackageChecks",
            "getPackageForms",
            'originPackageData',
        ]),

        ...mapState({
            entityTypeOptions: 'entityTypeList',
            isDirty: state => state.PackageStore.isDirty,
            originPackageData: state => state.PackageStore.originPackageData,
        }), 

        navigations() {
            return [
                {
                    title: this.$t('pages.tenant_packages.configuration'),
                    nav: "description",
                    icon: "file-lines",
                    subnav: false,
                    iconPrefix: "far",
                },
                // {
                //     title: this.$t('pages.tenant_packages.sla'),
                //     nav: "sla",
                //     icon: "clock",
                //     subnav: false,
                //     iconPrefix: "far",
                // },
                {
                    title: this.$t('pages.tenant_packages.checks'),
                    nav: "checks",
                    icon: "circle-check",
                    subnav: false,
                    iconPrefix: "far",
                },
                {
                    title: this.$t('pages.tenant_packages.form_editor'),
                    nav: "form-editor",
                    icon: "table",
                    subnav: false,
                    entityTypeTabs: true,
                },
                {
                    title: this.$t('pages.tenant_packages.form_preview'),
                    nav: "form-preview",
                    icon: "tv",
                    subnav: false,
                    entityTypeTabs: true,
                },
                {
                    title: this.$t('pages.tenant_packages.default_email_sequence'),
                    nav: "email",
                    icon: "envelope",
                    subnav: false,
                    iconPrefix: "far",
                },
                {
                    title: this.$t('pages.tenant_packages.email_template_sequence'),
                    nav: "email-template-sequence",
                    icon: "envelope",
                    subnav: false,
                    iconPrefix: "far",
                },
                {
                    title: this.$t('pages.tenant_packages.link_setting'),
                    nav: "link-setting",
                    icon: "link",
                    subnav: false,
                },
                {
                    title: this.$t('pages.tenant_packages.activity_history'),
                    nav: "audit",
                    icon: "history",
                    subnav: false,
                },
                {
                    title: this.$t('pages.tenant_packages.workflow'),
                    nav: "workflow",
                    icon: "file-lines",
                    subnav: false,
                    iconPrefix: "far",
                },
                {
                    title: this.$t('pages.tenant_packages.templates'),
                    nav: "templates",
                    icon: "file-lines",
                    subnav: false,
                    iconPrefix: "far",
                    hide: !(checkPermission('package.readTemplate') || checkPermission('package.editTemplate'))
                },
            ]
        },

        getPermission() {
            console.log("this.checkPermission('package.edit')", this.checkPermission('package.edit'))
            return this.$router.query !== 'view' ? this.checkPermission('package.edit') : false;
        },
        subDomainAvailable() {
            let selectedTab = this.currentTab;
            if (selectedTab) {
                let currentNav = this.navigations.find((ele) => ele.nav === selectedTab);
                return currentNav.subnav;
            } else {
                return "";
            }
        },
        screeningMenuWrapper() {
            return {
                description: {
                    el: Description,
                    props: {
                        beforeLeave: this.beforeLeaveTab
                    }
                },
                checks: {
                    el: Checks,
                },
                "email": {
                    el: EmailSequence,
                },
                "email-template-sequence":{
                    el :EmailTemplateSequence,
                },
                // "candidate-form": CandidateForm,
                // "referee-form": RefereeForm,
                sla: {
                    el: Tat,
                    props: {
                        beforeLeave: this.beforeLeaveTab
                    },
                },
                // "screener-form": ScreenerForm,
                // "client-form": ClientForm,
                // "welcome-screen": WelcomeScreen,
                "form-editor": {
                    el: FormEditor,
                    props: {
                        entityType: this.selectedEntityType,
                    },
                },
                "form-preview": {
                    el: FormPreview,
                    props: {
                        entityType: this.selectedEntityType,
                    },
                },
                'audit':{
                    el: Audit,
                },
                'link-setting': {
                    el: LinkSetting,
                },
                'workflow': {
                    el: Workflow,
                },
                'templates': {
                    el: Templates,
                },
                // 'risk-assessment': {
                //     el: RiskAssessment,
                // },
            }
        },
        currentTabConfig() {
            return {
                // need this to have access to the current tab config as we don't store it in this.currentTab
                tab: this.navigations.find((el) => el.nav === this.currentTab),
                component: this.screeningMenuWrapper[this.currentTab],
            }
        },
        entityTypeTabs() {
            const typeList = reorderPackageEntityTypes(this.getPackage?.entity_types)
            return typeList.map((el) => ({
                ...el,
                label: el.name,
            })) || []
        },
        showReplaceWorkflow() {
            return (this.currentTab =='workflow' && this.$route.params.action!='view' && this.getWorkflowId ? true : false);
        },
        getWorkflowId() {
            return this.$route.params?.packagetoolId
        },
        getVisibleNavigations() {
            return this.navigations.filter(nav => !nav.hide);
        },
        getPackageId() {
            return this.$route.params.packageName;
        },
        showRevettingWorkflow() {
            return !!this.selectedRevettingWorkflow;
        },
        fieldData() {
            return this.originPackageData;
        }
    },

    methods: {
        ...mapMutations(["RESET_PACKAGE"]),
        handleReplaceWorkflow() {
            this.$refs.workflow.handleAddDefault()
        },
        ...mapActions([
            "fetchPackageData",
            "fetchRoles",
            "fetchPackageSections",
            "fetchPackageChecks",
            "fetchEntityTypeList"
        ]),
        checkPermission,
        // fetch all necessary package data:
        async fetchPackage() {
            const package_id = this.$route.params.packageName
            await Promise.all([
                this.fetchPackageData(package_id),
                this.fetchPackageSections(package_id),
                this.fetchPackageChecks(package_id),
            ])
        },
        async beforeLeaveTab() {
            if (!this.isDirty) {
                return true
            } else {
                const promise = await this.$refs["confirm-popup"].show({
                    title: this.$t('general.are_you_sure'),
                    message: this.$t('general.confirm_unsaved_data_lost'),
                });

                if (promise) {
                    await this.fetchPackage();
                }
                return !!promise;
            }
        },

        closeDeletepackageModal() {
            this.deletePackageModalOpen = false;
        },

        async handleDeletePackage() {
             this.deletePackageModalOpen = true;
        },
        async getPackageAssignedUsers() {
            let url = `/screening-package/${this.originPackageData.id}/client-list`;
            let response = await rawAxios.get(url);
            this.assignedToClients = response.data;
        },

        async handleDelete(packageDetails) {
              let url = `/screening-package/${packageDetails.id}`;
              this.isDeleteLoading = true;
              try {
                let result = await rawAxios.delete(url);
                this.$router.push({ path: "/packages" });
                this.$toast.success(result.data.message);
                this.closeDeletePackageModal();
              } catch (error) {
                this.$toast.error(error.response.data.detail);
                this.closeDeletePackageModal();
              }
              this.isDeleteLoading = false;
        },

        closeDeletePackageModal() {
            this.deletePackageModalOpen = false;
        },
        /***
         *  triggers when tabs changed
         */
        async handleCurrentTab(tab) {
            let shouldLeaveTab = await this.beforeLeaveTab();

            if (!shouldLeaveTab || this.currentTab === tab.nav) return;
            this.resetSelectedEntityTab();
            this.currentTab = tab.nav;
            this.setBredCrumbs(this.currentTab);

            if (this.currentTab !== 'workflow'){
                this.$router.push({
                name: "Package Tools",
                params: { packagetool: this.currentTab },
                });
            } else {
                this.$router.push({
                    name: "Package Tools",
                    params: { packagetool: this.currentTab, type: "case" },
                });
                this.allowRevetting.loader =  true;
                await this.fetchRevettingWorkflowOptions();
                await this.fetchSelectedRevetting();
                this.allowRevetting.loader =  false;
                
            }
        },
        async fetchRevettingWorkflowOptions() {
            try {
                const { data } = await fetchStatusList('case');
                    this.allowRevetting.workflowOption = data.data.map((el) => ({
                    id: el?.id,
                    name: el.name,
                    description: el.description,
                }));
            } catch (err) {
                console.error("Error fetching revetting workflow options:", err);
                this.$toast.error(err?.response?.data?.status_message || err?.response?.data?.detail || this.$t('pages.general.default_error'));
            }
           
        },
        setSubBredCrumbs(crumb) {
            this.customBreadCumbs = [
                { name: this.currentTab },
                { name: crumb }
            ];
        },
        setBredCrumbs(crumb) {
            this.customBreadCumbs = [{ name: crumb }];
        },
        async setEditModeUnlock() {
            if(this.$route.params.action == 'view'){
                return
            }
            try {
                if(this.$route.params?.packageName){
                    let package_id = this.$route.params?.packageName
                    let payload = { lock_status: false }
                    let url = `/screening-package/locked/${package_id}`;
                    await rawAxios.post(url, payload);
                    EventBus.$emit('fetchtenantpackage');
                    return true;
                }
            } catch (error) {
                // hidden for 403 temporarily until further notified
                if (error.status !== 403) this.$toast.error(error.response.data.detail || this.$t('pages.tenant_packages.error_package_unlock'));
                return false; // Return false when there's an error
            }
        },
        resetSelectedEntityTab() {
            if (this.entityTypeTabs.length) this.selectedEntityType = this.entityTypeTabs[0]
        },
        async fetchEntityTypeOptions() {
            this.isEntityTypesLoading = true;
            if (!this.entityTypeOptions.length) {
                await this.fetchEntityTypeList();
            }
            this.isEntityTypesLoading = false;
        },
        getMenuItems() {},
        async onSelectAllowRevettingWorkflow(item) {
            if (!item) return;
            try{
                const url = `workflow/case/link/refresh_config/${item?.id}/${this.getPackageId}?allow_refresh=${this.allowRevetting.toggle}`; 
                const response = await rawAxios.post(url);
                if(response?.data?.status_message) {
                    this.$toast.success(response?.data?.status_message);
                }
            } catch(err) {
                console.log("error", err);
                this.$toast.error(err?.response?.data?.status_message || err?.response?.data?.detail || this.$t('pages.general.default_error'));
            } finally {
                this.selectedRevettingWorkflow = item;
            }
        },

        async fetchSelectedRevetting() {
            try {
                
                const url = `workflow/case/link/refresh_config/${this.getPackageId}`;
                const response = await rawAxios.get(url);
                if (response?.data?.data) {
                    this.selectedRevettingWorkflow = response?.data?.data[0];
                    this.allowRevetting.toggle = response?.data?.data[0]?.allow_refresh || false;
                } else {
                    this.selectedRevettingWorkflow = null;
                    this.allowRevetting.toggle = false;
                }
                this.allowRevetting.loader =  false;
            } catch (error) {
                this.allowRevetting.toggle = false;
                this.allowRevetting.loader =  false;
                console.error("Error fetching selected revetting workflow:", error);
                this.$toast.error(error?.response?.data?.status_message || error?.response?.data?.detail || this.$t('pages.general.default_error'));
            }
        },
        async handleAllowRefresh() {
            if (this.selectedRevettingWorkflow) {
                await this.onSelectAllowRevettingWorkflow(this.selectedRevettingWorkflow)
            }
        },
    },
};
</script>
<style scoped lang="scss">
.screeing_nav {
    border: 1px solid transparent;
}
.screeing_nav:hover {
    border: 1px solid #cdcdcd;
}
::v-deep {
    .ql-container {
        .ql-editor {
            min-height: 20rem;
            height: 20rem;
        }
    }
}
.description_height{
height: fit-content;
}
.entity-type-tabs {
    flex: 0 0 0;
}
</style>
